import { assoc } from 'ramda';
import {
  NAMESPACE, UPDATE_BOTSPECS, UPDATE_PARSING_BOTSPEC,
  UPDATE_EDITOR_ERROR, UPDATE_SELECTED_BOTSPEC, UPDATE_SELECTED_VARIABLE_GROUP,
  UPDATE_LOADING_BOTSPECS, UPDATE_SELECTED_STORAGE_GROUP, UPDATE_SELECTED_FUNCTION_GROUP,
  UPDATE_BOT_ERROR_GROUPS, UPDATE_BOT_ERRORS_DETAILS, LOADING_BOT_ERRORS_DETAILS,
  LOADING_BOT_ERROR_GROUPS, RESET_CHATBOTS, RESTORE_BOTSPEC_PAST_STATE,
  UPDATE_BOTSPEC_PARSER_ERRORS, CREATE_FOLDER, UPDATE_FOLDERS,
  UPDATE_TEMPLATES, UPDATE_CHATBOTS, UPDATE_CURRENT_BUSINESS_UNITS, RESET_SELECTIONS,
} from '../namespace';

const initialState = () => ({
  selectedBotspec: '',
  selectedVariableGroup: '',
  selectedFunctionGroup: '',
  selectedStorageGroup: '',
  botspecs: {},
  folders: {},
  parsing: false,
  editorError: null,
  loadingBotspecs: true,
  parsingErrors: [],
  past: {},
  templates: [],
  chatbots: [],
  currentBusinessUnits: [],
});

const reducer = (state = initialState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_SELECTED_BOTSPEC:
      return assoc('selectedBotspec', payload.id, state);
    case UPDATE_SELECTED_VARIABLE_GROUP:
      return assoc('selectedVariableGroup', payload.groupId, state);
    case UPDATE_SELECTED_FUNCTION_GROUP:
      return assoc('selectedFunctionGroup', payload.groupId, state);
    case UPDATE_SELECTED_STORAGE_GROUP:
      return assoc('selectedStorageGroup', payload.groupId, state);
    case RESET_SELECTIONS:
      return {
        ...state,
        selectedVariableGroup: '',
        selectedFunctionGroup: '',
        selectedStorageGroup: '',
      };
    case UPDATE_BOTSPECS:
      return {
        ...state,
        botspecs: payload.botspecs,
        past: { botspecs: state.botspecs },
      };
    case UPDATE_PARSING_BOTSPEC:
      return assoc('parsing', payload.value, state);
    case UPDATE_EDITOR_ERROR:
      return assoc('editorError', payload.value, state);
    case UPDATE_LOADING_BOTSPECS:
      return assoc('loadingBotspecs', payload.value, state);
    case LOADING_BOT_ERROR_GROUPS: {
      const botspecs = { ...state.botspecs };
      botspecs[payload.id] = {
        ...botspecs[payload.id],
        loadingErrorGroups: payload.loading,
      };
      return {
        ...state,
        botspecs,
        past: { botspecs: state.botspecs },
      };
    }
    case UPDATE_BOT_ERROR_GROUPS: {
      const botspecs = { ...state.botspecs };
      botspecs[payload.id] = {
        ...botspecs[payload.id],
        errorsInfo: payload.errorsGroups,
        loadingErrorGroups: false,
      };
      return assoc('botspecs', botspecs, state);
    }
    case LOADING_BOT_ERRORS_DETAILS: {
      const botspecs = { ...state.botspecs };
      botspecs[payload.id] = {
        ...botspecs[payload.id],
        errorsInfo: {
          ...botspecs[payload.id].errorsInfo,
          loadingDetails: payload.loading,
        },
      };
      return assoc('botspecs', botspecs, state);
    }
    case UPDATE_BOT_ERRORS_DETAILS: {
      const botspecs = { ...state.botspecs };
      const botspec = { ...botspecs[payload.id] };
      const errorsInfo = { ...botspec.errorsInfo };
      const groupIndex = errorsInfo.errors.findIndex((errorGroup) => (
        errorGroup.groupId === payload.gid
      ));
      errorsInfo.errors[groupIndex].details = {
        ...errorsInfo.errors[groupIndex].details,
        ...payload.errorsDetails,
      };
      errorsInfo.loadingDetails = false;
      botspec.errorsInfo = { ...errorsInfo };
      botspecs[payload.id] = { ...botspec };
      return assoc('botspecs', botspecs, state);
    }
    case RESTORE_BOTSPEC_PAST_STATE: {
      const botspecs = { ...state.botspecs };
      const botspec = { ...state.past.botspecs[payload.id] };
      botspecs[payload.id] = { ...botspec };
      return assoc('botspecs', botspecs, state);
    }
    case RESET_CHATBOTS:
      return initialState();
    case UPDATE_BOTSPEC_PARSER_ERRORS:
      return assoc('parsingErrors', payload.errors, state);
    case CREATE_FOLDER:
      return { ...state, folders: { ...state.folders, [payload.folder.id]: payload.folder } };
    case UPDATE_FOLDERS:
      return {
        ...state,
        folders: { ...payload.folders },
      };
    case UPDATE_TEMPLATES:
      return {
        ...state,
        templates: [...payload.templates],
      };
    case UPDATE_CHATBOTS:
      return {
        ...state,
        chatbots: [...payload.value],
      };
    case UPDATE_CURRENT_BUSINESS_UNITS:
      return {
        ...state,
        currentBusinessUnits: [...payload.value],
      };
    default:
      return state;
  }
};

export default { [NAMESPACE]: reducer };
